module.exports = __webpack_public_path__ + "static/media/paywall.44a691dd.svg";